import { t } from 'i18next';
import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import { baseStyles } from '@/styles';

@customElement('fg-configuration-error')
export class FgConfigurationError extends LitElement {
  render() {
    return html`
      <p>${t('errors.configurationProductNotFound')}</p>
    `;
  }

  static styles = [baseStyles];
}
